global.myPayments = {
		unlockCustomizeProfile:function(options) {
			// check if we have not already unlocked it and show an error
			otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=profile.requestPaidUnlockCustomizeProfile',{},
					{   debug:false,
						responseType:'json',
						callback:function (json) {
							if (json.success) {
								// ok we can charge now
								var price=json.data.price;
								stripe.loadAsync({
									publicKey:options.publicKey,
									callback:function() {
							      		  if (stripe.isLoaded()) {
								      		  stripe.pay({
													amount:json.data.price*100,
													description:json.data.description,
													email:json.data.email,
													token:function(stripeToken) {						
														console.log('Payments - stripe token authorised..');
														var postData={
															stripeToken:JSON.stringify(stripeToken)
														};
														otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=profile.processPaidUnlockCustomizeProfile',
															postData,
																{
																debug:false,
																responseType:'json',
																callback:function (json) {
																	if (json.success) {
																		console.log('Payments - Success');
																	}
																}
															}
														);

													}
												});
										} else {
											console.log('Payments - Unexpected error stripe not loaded')}
										}
								});
								console.log('Payments - Waiting for stripe to load');
								
							} else {
								console.log('Payments - Unexpected end of request');
							}
						}
					});
		},
		unlockCustomizeRaft:function(options) {
			// check if we have not already unlocked it and show an error
			otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=raft.requestPaidUnlockCustomizeRaft',{},
					{   debug:false,
						responseType:'json',
						callback:function (json) {
							if (json.success) {
								// ok we can charge now
								var price=json.data.price;
								stripe.loadAsync({
									publicKey:options.publicKey,
									callback:function() {
							      		  if (stripe.isLoaded()) {
								      		  stripe.pay({
													amount:json.data.price*100,
													description:json.data.description,
													email:json.data.email,
													token:function(stripeToken) {						
														console.log('Payments - stripe token authorised..');
														var postData={
															stripeToken:JSON.stringify(stripeToken)
														};
														otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=raft.processPaidUnlockCustomizeRaft',
															postData,
																{
																debug:false,
																responseType:'json',
																callback:function (json) {
																	if (json.success) {
																		console.log('Payments - Success');
																	}
																}
															}
														);

													}
												});
										} else {
											console.log('Payments - Unexpected error stripe not loaded')}
										}
								});
								console.log('Payments - Waiting for stripe to load');
								
							} else {
								console.log('Payments - Unexpected end of request');
							}
						}
					});
		},
		unlockCatchAWaveDoublePoints:function(options) {
			// check if we have not already unlocked it and show an error
			otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=catchAWave.requestPaidUnlockDoublePoints',{},
					{   debug:false,
						responseType:'json',
						callback:function (json) {
							if (json.success) {
								// ok we can charge now
								var price=json.data.price;
								stripe.loadAsync({
									publicKey:options.publicKey,
									callback:function() {
							      		  if (stripe.isLoaded()) {
								      		  stripe.pay({
													amount:json.data.price*100,
													description:json.data.description,
													email:json.data.email,
													token:function(stripeToken) {						
														console.log('Payments - stripe token authorised..');
														var postData={
															stripeToken:JSON.stringify(stripeToken)
														};
														otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=catchAWave.processPaidUnlockDoublePoints',
															postData,
																{
																debug:false,
																responseType:'json',
																callback:function (json) {
																	if (json.success) {
																		console.log('Payments - Success');
																	}
																}
															}
														);

													}
												});
										} else {
											console.log('Payments - Unexpected error stripe not loaded')}
										}
								});
								console.log('Payments - Waiting for stripe to load');
								
							} else {
								console.log('Payments - Unexpected end of request');
							}
						}
					});
		}
		
		
}